import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import AsttButtonDark from "components/ASTTButtonDark/AsttButtonDark";
import { useTranslation } from "react-i18next";
import BackdropComponent from "components/Spinner/Spinner";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import {
  createIdmOrderRequest,
  getIdmRitmDetail,
  SaveAttachmentRitm,
  insertIdmTicket,
  SaveRitmComment,
  SaveAttachmentRitmForClient,
  SaveAttachmentRitmForCapClient,
  getTraineeDetailsForIDMTicketByRosterId,
  insertIdmEmailQueue,
  insertFacilitiesTicket,
} from "services/userServices";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import moment from "moment";

import SpinnerWithTime from "components/Spinner/SpinnerWithTime";

import { DataGrid } from "@mui/x-data-grid";

import CreateIdmTicketsInputs from "./CreateIdmTicketsInputs";
import { askNowActions } from "Store/AskNowTicket";
import SnackBar from "components/SnackBar/SnackBar";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  height: 650,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const showAfterTimeout = (func, seconds) => {
  setTimeout(() => {
    func(true);
  }, seconds);
};

const columns = [
  {
    field: "oracleId",
    headerName: "OracleId",
    type: "number",
    headerAlign: "left",
    align: "left",
    width: 80,
    hideable: false,
  },
  {
    field: "firstName",
    headerName: "First Name",
    type: "string",
    headerAlign: "left",
    align: "left",
    width: 120,
  },
  {
    field: "lastName",
    headerName: "Last Name",
    type: "string",
    headerAlign: "left",
    align: "left",
    width: 120,
  },
  {
    field: "dateAssigned",
    headerName: "Date Assigned",
    type: "date",
    headerAlign: "left",
    align: "left",
    width: 150,
  },
  {
    field: "candidateID",
    headerName: "Candidate Id",
    type: "number",
    headerAlign: "left",
    align: "left",
    width: 110,
  },
  {
    field: "activeInAD",
    headerName: "Active in AD",
    type: "string",
    headerAlign: "left",
    align: "left",
    width: 100,
  },
  {
    field: "RITM",
    headerName: "RITM#",
    type: "string",
    headerAlign: "left",
    align: "left",
    width: 120,
  },
  {
    field: "cppClientCode",
    headerName: "CPP Client Code",
    type: "number",
    headerAlign: "left",
    align: "left",
    width: 120,
  },
  {
    field: "cppProgramCode",
    headerName: "CPP Program Code",
    type: "number",
    headerAlign: "left",
    align: "left",
    width: 140,
  },
  {
    field: "cppProjectCode",
    headerName: "CPP Project Code",
    type: "number",
    headerAlign: "left",
    align: "left",
    width: 140,
  },
  {
    field: "locationId",
    headerName: "Location Id",
    type: "number",
    headerAlign: "left",
    align: "left",
    width: 120,
  },
  {
    field: "jobTitle",
    headerName: "Job Code",
    type: "number",
    headerAlign: "left",
    align: "left",
    minWidth: 330,
  },
  {
    field: "department",
    headerName: "Department",
    type: "number",
    headerAlign: "left",
    align: "left",
    width: 330,
  },
  {
    field: "classTraineeID",
    headerName: "Class Trainee Id",
    type: "number",
    headerAlign: "left",
    align: "left",
  },
];

const prepareCreateIDMRequestPayload = (askNowDetail) => ({
  sysparm_quantity: 1,
  variables: {
    cmdb_ci: "dad2e7294ffa1280f15e3285f110c7ff",
    caller_id: askNowDetail.requestFor,
    idm_requested_date:
      askNowDetail.reqForDateTime.date + " " + askNowDetail.reqForDateTime.time,
    idm_access_type:
      askNowDetail.typeOfRequest === "Activation (New Hire or Reactivation)"
        ? "Activation"
        : askNowDetail.typeOfRequest,
    idm_multiple_porgram: "yes",
    idm_emp_type: "agent",
    idm_wave_number: askNowDetail.waveNumber,
    idm_request_number: askNowDetail.taleoReqId,
    tci_ttd_start_date: askNowDetail.tCITTDStartDate,
    idm_tte_training_date: askNowDetail.tteTrainingDate,
    product_training_start_date: askNowDetail.productionTrainingStart,
    idm_production_date: askNowDetail.productionDate,
    idm_site: askNowDetail.siteLocation,
    idm_new_cp: askNowDetail.newClientProgram,
    technology_Deployment_Type: askNowDetail.techDeploymentType,
    idm_wave_trainer: askNowDetail.waveTrainer,
    idm_ops_manager: askNowDetail.manager,
    idm_product_training_date: askNowDetail.tteTrainingDate,
    requested_for_time: askNowDetail.timeZone,
    system_account_provisioning_only: askNowDetail.noEquipmentRequired,
    idm_mul_cp2:
      askNowDetail.typeOfRequest === "Change Role"
        ? askNowDetail.currentClientProgram
        : [askNowDetail.newClientProgram],
  },
});

const getAppBarClassName = () => {
  if (window.location.host !== "astt.ttec.com") {
    return "env-devcolor";
  }
  return "env-prodcolor";
};

const IDMGenerateResponseModal = (props) => {
  const {
    generateOpen,
    traineeForShow,
    isTraineeNotSelected,
    taleoReqIdShow,
    isRuleFailTaleoReqId,
    requestedForShow,
    isRuleFailRequestedFor,
    isReqDateTime,
    askNowDetail,
    isReqTimeZone,
    tteDateForShow,
    isRuleFailTteDate,
    siteLocShow,
    isRuleFailSiteLocation,
    ncShow,
    isCurrentClientProgram,
    isNewClientProgram,
    wtShow,
    isRuleFailWaveTrainer,
    managerShow,
    isRuleFailManager,
    createAskNowHeading,
    createAskNowSuccess,
    createAskNowFacilitiesHeading,
    createAskNowFacilitiesSuccess,
    reqNumber,
    facNumber,
    ritmHeading,
    ritmShow,
    ritmNumber,
    uploadRitmHeading,
    showRitmUpload,
    showHeadsetNoticifation,
    idmTicketError,
    facTicketError,
    finishedGenrating,
    closeGeneratingAskNowTicket,
  } = props;
  return (
    <Modal
      open={generateOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div>
          <p className={"text-center m-20px fs-1-5"}>
            Generating Ask Now Ticket
          </p>
          <p>--Verifying AskNow SysId Values--</p>

          {traineeForShow && (
            <p className="main-section m-5-0px">
              Trainees:
              {isTraineeNotSelected ? (
                <span className="redColor">
                  No trainee selected from table!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {taleoReqIdShow && (
            <p className="main-section m-5-0px">
              Taleo Req Id:
              {isRuleFailTaleoReqId ? (
                <span className="redColor">
                  Please see Taleo Req, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {requestedForShow && (
            <p className="main-section m-5-0px">
              Requested For:
              {isRuleFailRequestedFor ? (
                <span className="redColor">
                  Please see Requested For, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          <p className="main-section m-5-0px">
            Req. For Date/Time :
            {isReqDateTime ? (
              <span className="redColor">
                Please see Req. For Date/Time, Some error occurred while
                updating values!
              </span>
            ) : (
              <span className="blueColor">OK</span>
            )}
          </p>
          {askNowDetail.typeOfRequest === "Change Role" && (
            <p className="main-section m-5-0px">
              Req. For TimeZone :
              {isReqTimeZone ? (
                <span className="redColor">
                  Please see Req. For TimeZone, Some error occurred while
                  updating values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {tteDateForShow && (
            <p className="main-section m-5-0px">
              TTE Date:
              {isRuleFailTteDate ? (
                <span className="redColor">
                  Please see TTE Date, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {siteLocShow && (
            <p className="main-section m-5-0px">
              Site/Location:
              {isRuleFailSiteLocation ? (
                <span className="redColor">
                  Please see Site/Location, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {ncShow && (
            <p className="main-section m-5-0px">
              New Client Program:
              {isNewClientProgram ? (
                <span className="redColor">
                  Please see New Client Program, Some error occurred while
                  updating values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {askNowDetail.typeOfRequest === "Change Role" && (
            <p className="main-section m-5-0px">
              Current Client Program:
              {isCurrentClientProgram ? (
                <span className="redColor">
                  Please see Current Client Program, Some error occurred while
                  updating values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {wtShow && (
            <p className="main-section m-5-0px">
              Wave Trainer:
              {isRuleFailWaveTrainer ? (
                <span className="redColor">
                  Please see Wave Trainer, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {managerShow && (
            <p className="main-section m-5-0px">
              Manager:
              {isRuleFailManager ? (
                <span className="redColor">
                  Please see Manager, Some error occurred while updating values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {createAskNowHeading && (
            <p className="m-15-0 font-bolder ">--Creating AskNow Ticket--</p>
          )}
          {createAskNowSuccess && (
            <p className="m-5-0px">{reqNumber} Successfully Created!</p>
          )}
          {ritmHeading && (
            <p className="m-15-0 font-bolder ">
              --Getting RITM Ticket Number--
            </p>
          )}
          {ritmShow && <p className="m-5-0px">{ritmNumber} Found!</p>}

          {uploadRitmHeading && (
            <p className="m-15-0 font-bolder ">
              --Uploading Onboarding Template to RITM ticket--
            </p>
          )}
          {showRitmUpload && (
            <p className="m-5-0px">
              OBT Successfully Uploaded to {ritmNumber} !
            </p>
          )}
          {createAskNowFacilitiesHeading && (
            <p className="m-15-0 font-bolder ">
              --Creating AskNow Facilities Ticket--
            </p>
          )}
          {createAskNowFacilitiesSuccess && (
            <p className="m-5-0px">
              {facNumber} Successfully Created, please review the details to
              ensure all information is accurate!
            </p>
          )}

          {showHeadsetNoticifation && (
            <p className="m-5-0px">Headset Email Notification - Success!</p>
          )}

          {idmTicketError && (
            <p className="main-section m-5-0px">
              <span className="redColor">
                Unable to create ticket. Please wait for some time before you
                retry. If this issue reoccurs, please report this issue and
                include the error shown below.
              </span>
            </p>
          )}

          {facTicketError && (
            <p className="main-section m-5-0px">
              <span className="redColor">
                Unable to create Facilities ticket. Please wait for some time
                before you retry. If this issue reoccurs, please report this
                issue and include the error shown below.
              </span>
            </p>
          )}
          {finishedGenrating && (
            <div className="text-center m-20px">
              <AsttButtonDark onClick={closeGeneratingAskNowTicket}>
                Close
              </AsttButtonDark>
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
};

IDMGenerateResponseModal.propTypes = {
  generateOpen: PropTypes.bool,
  traineeForShow: PropTypes.bool,
  isTraineeNotSelected: PropTypes.bool,
  taleoReqIdShow: PropTypes.bool,
  isRuleFailTaleoReqId: PropTypes.bool,
  requestedForShow: PropTypes.bool,
  isRuleFailRequestedFor: PropTypes.bool,
  isReqDateTime: PropTypes.bool,
  askNowDetail: PropTypes.object,
  isReqTimeZone: PropTypes.bool,
  tteDateForShow: PropTypes.bool,
  isRuleFailTteDate: PropTypes.bool,
  siteLocShow: PropTypes.bool,
  isRuleFailSiteLocation: PropTypes.bool,
  ncShow: PropTypes.bool,
  isCurrentClientProgram: PropTypes.bool,
  isNewClientProgram: PropTypes.bool,
  wtShow: PropTypes.bool,
  isRuleFailWaveTrainer: PropTypes.bool,
  managerShow: PropTypes.bool,
  isRuleFailManager: PropTypes.bool,
  createAskNowHeading: PropTypes.bool,
  createAskNowSuccess: PropTypes.bool,
  createAskNowFacilitiesHeading: PropTypes.bool,
  createAskNowFacilitiesSuccess: PropTypes.bool,
  reqNumber: PropTypes.string,
  facNumber: PropTypes.string,
  ritmHeading: PropTypes.bool,
  ritmShow: PropTypes.bool,
  ritmNumber: PropTypes.string,
  uploadRitmHeading: PropTypes.bool,
  showRitmUpload: PropTypes.bool,
  showHeadsetNoticifation: PropTypes.bool,
  idmTicketError: PropTypes.bool,
  facTicketError: PropTypes.bool,
  finishedGenrating: PropTypes.bool,
  closeGeneratingAskNowTicket: PropTypes.func,
};

const CreateIdmTickets = (props) => {
  //will remove IDMTicketDisplay hook in future once IDM ticket creation get available for everyone. For QA only.
  // const [IDMTicketDisplay, setIDMTicketDisplay] = useState(false); --ASTT-2156
  const [idmTicketError, setIdmTicketError] = useState(false);
  const [facTicketError, setFacTicketError] = useState(false);
  const { t } = useTranslation(["rosterConfig"]);
  const [openCreateIdm, setOpenCreateIdm] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [isCurrentClientProgram, setIsCurrentClientProgram] = useState(false);
  const askNowDetail = useSelector((state) => state.askNow);
  const traineeDetails = useSelector((state) => state.generalStore);
  const [isRuleFailTaleoReqId, setIsRuleFailTaleoReqId] = useState(false);
  const [taleoReqIdShow, setTaleoReqIdShow] = useState(false);
  const [isTraineeNotSelected, setIsTraineeNotSelected] = useState(false);
  const [isRuleFailRequestedFor, setIsRuleFailRequestedFor] = useState(false);
  const [isReqDateTime, setIsReqDateTime] = useState(false);
  const [isReqTimeZone, setIsReqTimeZone] = useState(false);
  const [isRuleFailSiteLocation, setIsRuleFailSiteLocation] = useState(false);
  const [isNewClientProgram, setIsNewClientProgram] = useState(false);
  const [isRuleFailWaveTrainer, setIsRuleFailWaveTrainer] = useState(false);
  const [isRuleFailManager, setIsRuleFailManager] = useState(false);
  const [isRuleFailTteDate, setIsRuleFailTteDate] = useState(false);
  const [resetActiveTrainee, setResetActiveTrainee] = useState(false);
  const [traineeForShow, setTraineeForShow] = useState(false);
  const [tteDateForShow, setTteDateForShow] = useState(false);
  const [requestedForShow, setRequestedForShow] = useState(false);
  const [siteLocShow, setSiteLocShow] = useState(false);
  const [ncShow, setNcShow] = useState(false);
  const [wtShow, setWtShow] = useState(false);
  const [managerShow, setManagerShow] = useState(false);
  const [finishedGenrating, setFinishedGenrating] = useState(false);
  const [createAskNowHeading, setCreateAskNowHeading] = useState(false);
  const [createAskNowSuccess, setCreateAskNowSuccess] = useState(false);
  const [reqNumber, setReqNumber] = useState("");
  const [facNumber, setFacNumber] = useState("");
  const [ritmHeading, setRitmHeading] = useState(false);
  const [ritmShow, setRitmShow] = useState(false);
  const [ritmNumber, setRitmNumber] = useState("");
  const [uploadRitmHeading, setUploadRitmHeading] = useState(false);
  const [showRitmUpload, setShowRitmUpload] = useState(false);
  const [showHeadsetNoticifation, setshowHeadsetNoticifation] = useState(false);

  const [createAskNowFacilitiesHeading, setCreateAskNowFacilitiesHeading] =
    useState(false);
  const [createAskNowFacilitiesSuccess, setCreateAskNowFacilitiesSuccess] =
    useState(false);

  const [requestType, setRequestType] = useState(
    "Activation (New Hire or Reactivation)",
  );
  const [idmLoading, setIdmLoading] = useState(false);
  const [currentProjectCodes, setCurrentProjectCodes] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [traineeData, setTraineeData] = useState([]);
  const [isTicketClosed, setIsTicketClosed] = useState(true);
  const dispatch = useDispatch();

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    setIdmLoading(traineeDetails.loadingState);
  }, [traineeDetails.loadingState]);

  useEffect(() => {
    setRequestType(askNowDetail.typeOfRequest);
  }, [askNowDetail.typeOfRequest]);

  useEffect(() => {
    if (resetActiveTrainee === true) {
      dispatch(askNowActions.activeTrainee(""));
      setSelectedRows([]);
    }
  }, [resetActiveTrainee, dispatch]);

  useEffect(() => {
    if (selectedRows.length > 0) {
      dispatch(askNowActions.activeTrainee(selectedRows));
    } else {
      dispatch(askNowActions.activeTrainee(""));
    }
  }, [selectedRows, dispatch]);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoading(true);
        setOpenCreateIdm(true);
        dispatch(askNowActions.resetTraineeDetailsResponse());
      }

      try {
        const traineeDetails = await getTraineeDetailsForIDMTicketByRosterId(
          props.rosterId,
        );

        if (cancelled) return;

        if (traineeDetails.message === "Success") {
          if (!cancelled) {
            dispatch(
              askNowActions.updateTraineeDetailsResponse(traineeDetails),
            );
            setResetActiveTrainee(false);

            const uniqueTraineeData = traineeDetails.data["traineeDetails"].map(
              (trainee, index) => ({
                ...trainee,
                uniqueId: `${trainee.oracleId}-${index}`,
              }),
            );

            setTraineeData(uniqueTraineeData);

            dispatch(
              askNowActions.waveNumber(
                traineeDetails.data["rosterDetail"]["wave"],
              ),
            );
            dispatch(
              askNowActions.reqForDateTime(
                traineeDetails.data["rosterDetail"]["reqDateTime"],
              ),
            );
            dispatch(
              askNowActions.tCITTDStartDate(
                props.ttfTrainerData[0] !== null
                  ? props.ttfTrainerData[0]
                  : props.ttfTrainerData[1] !== null
                    ? props.ttfTrainerData[1]
                    : props.ttfTrainerData[2],
              ),
            );
            dispatch(
              askNowActions.productionTrainingStart(
                traineeDetails.data["rosterDetail"]["productTrainingDate"] !==
                  null
                  ? traineeDetails.data["rosterDetail"]["productTrainingDate"]
                  : props.ttfTrainerData[4],
              ),
            );
            dispatch(
              askNowActions.productionDate(
                traineeDetails.data["rosterDetail"]["productionDate"] !== null
                  ? traineeDetails.data["rosterDetail"]["productionDate"]
                  : props.ttfTrainerData[3],
              ),
            );
            dispatch(
              askNowActions.currentClientProgram(
                traineeDetails.data["rosterDetail"]["cppProjectCode"],
              ),
            );

            setLoading(false);
          }
        } else {
          if (!cancelled) {
            setResetActiveTrainee(true);
            setLoading(false);
            setSnack({
              open: true,
              message: "Failed to load trainees",
              severity: "error",
            });
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch trainee details:", error);
          setLoading(false);
        }
      }
    };

    if (isTicketClosed) {
      fetchData();
      setIsTicketClosed(false);
    }

    return () => {
      cancelled = true;
    };
  }, [props.rosterId, isTicketClosed, dispatch]);

  useEffect(() => {
    setLoading(true);

    setCurrentProjectCodes(
      traineeData?.map((trainees) => {
        return {
          uniqueId: trainees.uniqueId,
          oracleId: trainees.oracleId,
          firstName: trainees.preferredFirstName,
          lastName: trainees.preferredLastName,
          dateAssigned: trainees.dateAdded
            ? moment(trainees.dateAdded).format("YYYY-MM-DDThh:mm:ss A")
            : null,
          candidateID: trainees.candidateId,
          classTraineeID: trainees.classTraineeId,
          RITM: trainees.idmTicketNumber,
          cppClientCode: trainees.cppClientCode,
          cppProgramCode: trainees.cppProgramCode,
          cppProjectCode: trainees.cppProjectCode,
          activeInAD: trainees.activeInAD === true ? "Yes" : "No",
          jobTitle: trainees.jobTitle,
          locationId: trainees.locationId,
          department: trainees.department,
        };
      }),
    );

    const cppRowData = traineeData?.map((row) => row.cppProjectCode);
    dispatch(askNowActions.currentProjectCodes(cppRowData));

    setLoading(false);
  }, [traineeData, dispatch]);

  const hanldeIdmClose = async () => {
    setOpenCreateIdm(false);
    setResetActiveTrainee(true);
    props.onClose();
  };

  const [generateOpen, setGenerateOpen] = React.useState(false);

  const createIdmTicketRequest = prepareCreateIDMRequestPayload(askNowDetail);

  const prepareActiveTrainees = (data) => {
    const isChangeRoleRequest = askNowDetail.typeOfRequest === "Change Role";
    return data.activeTrainee.map((item) => {
      return {
        oracleId: item.oracleId,
        firstName: item.firstName,
        lastName: item.lastName,
        cppClientCode: isChangeRoleRequest
          ? askNowDetail.newClientCode
          : item.cppClientCode,
        cppProgramCode: isChangeRoleRequest
          ? askNowDetail.newProgramCode
          : item.cppProgramCode,
        cppProjectCode: isChangeRoleRequest
          ? askNowDetail.newProjectCode
          : item.cppProjectCode,
        jobTitle: item.jobTitle,
        department: item.department,
        locationId: item.locationId,
        tdt: askNowDetail.techDeploymentType,
      };
    });
  };

  const doesClientNameInclude = (name) =>
    askNowDetail.clientName.toLowerCase().includes(name.toLowerCase());

  const saveAttachment = async (payload) => {
    const response = await SaveAttachmentRitm(payload);
    let isClientSpecific = false;
    if (
      doesClientNameInclude("century") ||
      doesClientNameInclude("kaiser") ||
      doesClientNameInclude("booking")
    ) {
      isClientSpecific = true;
      let clientTrainees = askNowDetail.activeTrainee.map((item) => {
        return {
          oracleId: item.oracleId,
          firstName: item.firstName,
          lastName: item.lastName,
          requestType: askNowDetail.typeOfRequest,
        };
      });
      let AttachForClientPayload = {
        Table_sys_id: payload?.Table_sys_id,
        Trainees: clientTrainees,
      };

      const clientResponse = await SaveAttachmentRitmForClient(
        AttachForClientPayload,
      );

      if (response.status === true && clientResponse.status === true) {
        setTimeout(() => {
          setShowRitmUpload(true);
          setUploadRitmHeading(true);
        }, 7000);
      }
    }

    if (doesClientNameInclude("capital one")) {
      isClientSpecific = true;
      let clientTrainees = askNowDetail.activeTrainee.map((item) => {
        return {
          oracleId: item.oracleId,
          firstName: item.firstName,
          middleName: "",
          lastName: item.lastName,
        };
      });
      let AttachForClientPayload = {
        Table_sys_id: payload?.Table_sys_id,
        Trainees: clientTrainees,
      };

      const clientResponse = await SaveAttachmentRitmForCapClient(
        AttachForClientPayload,
      );

      if (response.status === true && clientResponse.status === true) {
        setTimeout(() => {
          setShowRitmUpload(true);
          setUploadRitmHeading(true);
        }, 7000);
      }
    }

    if (response.status === true && !isClientSpecific) {
      setTimeout(() => {
        setShowRitmUpload(true);
        setUploadRitmHeading(true);
      }, 7000);
    }
  };

  const insertTicket = async (idmTicketNumber) => {
    let trainees = askNowDetail.activeTrainee.map((item) => {
      return {
        classTraineeId: item.classTraineeId,
      };
    });

    let payload = {
      classRosterId: props.rosterId,
      idmTicketNumber: idmTicketNumber,
      createdBy: localStorage.getItem("User"),
      classTrainees: trainees,
    };

    await insertIdmTicket(idmTicketNumber, payload, props.rosterId, false);
  };

  const insertComment = async (RITMRequest) => {
    const ritmNumber = RITMRequest.data["result"].number;
    let reportPII = `${window.location.origin}/contact-roster/${props.rosterId}' target="_blank"`;
    let ritmSysId = RITMRequest.data["result"].sysid;
    let reportName = `${window.location.origin}/OBT/${ritmNumber}' target="_blank"`;

    const shippingReport = `${window.location.origin}/shipping/${ritmNumber}' target="_blank"`;
    let workNote = `[code]<a href='${reportName}>${window.location.origin}/OBT/${ritmNumber}
          </a> </br> </br>  <a href='${reportPII}>${window.location.origin}/contact-roster/${props.rosterId}</a>
          </br> </br>
          <a href='${shippingReport}>${window.location.origin}/shipping/${ritmNumber}</a>
          [/code]`;

    let payloadComment = {
      work_Notes: workNote,
    };

    await SaveRitmComment(ritmSysId, payloadComment);
  };

  const RITMPostCreationProcess = async (requestSysId) => {
    const getRitmRequest = await getIdmRitmDetail(requestSysId);
    if (getRitmRequest.status === true) {
      setRitmNumber(getRitmRequest.data["result"].number);

      showAfterTimeout(setRitmHeading, 8000);

      setTimeout(() => {
        setRitmShow(true);
        setUploadRitmHeading(true);
      }, 9000);

      let SysId = getRitmRequest.data["result"].sysid;

      let selectedTrainees = prepareActiveTrainees(askNowDetail);

      let traineesPayload = {
        Table_sys_id: SysId,
        Trainees: selectedTrainees,
      };

      await saveAttachment(traineesPayload);

      await insertTicket(getRitmRequest.data["result"].number);

      await insertComment(getRitmRequest);

      //Idm Email Queue
      const oracleIds = traineesPayload.Trainees.map(
        (trainee) => trainee.oracleId,
      );
      let payload = prepareInsertPayload(
        oracleIds,
        getRitmRequest.data["result"].number,
      );

      if (props.ttfTrainerData[8]) {
        const description = selectedTrainees
          .map(
            (item) =>
              `[oracleId: "${
                item.oracleId
              }", name: "${`${item.firstName} ${item.lastName}`}", startDate: "${
                askNowDetail.tteTrainingDate != null
                  ? askNowDetail.tteTrainingDate
                  : askNowDetail.productionTrainingStart
              }"]`,
          )
          .join(",");

        showAfterTimeout(setCreateAskNowFacilitiesHeading, 4000);
        const facilitiesResponse = await insertFacilitiesTicket(
          askNowDetail.requestForrOracleId,
          askNowDetail.siteLocationName,
          askNowDetail.siteLocation,
          description,
        );
        if (facilitiesResponse.status === true) {
          showAfterTimeout(setCreateAskNowFacilitiesSuccess, 9000);
          const objReqDetails = JSON.parse(facilitiesResponse["data"]);
          setFacNumber(objReqDetails["result"].number);
        } else {
          showAfterTimeout(setFacTicketError, 9000);
        }

        if (
          askNowDetail.typeOfRequest === "Activation (New Hire or Reactivation)"
        ) {
          await insertIdmEmailQueue(payload);
          setTimeout(() => {
            setshowHeadsetNoticifation(true);
          }, 3000);
        }
      }
      setResetActiveTrainee(false);
    }
  };

  const prepareInsertPayload = (oracleIds, idmTicketNumber) => ({
    classRosterId: props.rosterId,
    waveTrainerOracleId: askNowDetail.waveTrainerOracleId,
    managerOracleId: askNowDetail.managerOracleId,
    requestForOracleId: askNowDetail.requestForrOracleId,
    siteLocationName: askNowDetail.siteLocationName,
    newClientProgramName: askNowDetail.newClientProgramName,
    ticketNumber: idmTicketNumber,
    statusId: 0,
    Trainees: oracleIds.join(","),
    createdBy: localStorage.getItem("OracleId"),
  });

  const createTicket = async () => {
    showAfterTimeout(setCreateAskNowHeading, 4000);
    const createOrderRequest = await createIdmOrderRequest(
      createIdmTicketRequest,
    );
    if (createOrderRequest.status === true) {
      showAfterTimeout(setCreateAskNowSuccess, 6000);
      const objReqDetails = JSON.parse(createOrderRequest["data"]);
      setReqNumber(objReqDetails["result"].number);
      const reqSysId = objReqDetails["result"].sys_id;
      await RITMPostCreationProcess(reqSysId);
    } else {
      showAfterTimeout(setIdmTicketError, 9000);
    }
  };

  const ValidateCreateIdmTicket = async () => {
    setGenerateOpen(true);
    let isValidationFail = false;
    showAfterTimeout(setTraineeForShow, 1000);
    showAfterTimeout(setRequestedForShow, 1000);
    showAfterTimeout(setTaleoReqIdShow, 1000);

    if (askNowDetail.reqForDateTime === "") {
      isValidationFail = true;
      showAfterTimeout(setIsReqDateTime, 1000);
    }
    if (
      askNowDetail.typeOfRequest === "Change Role" &&
      askNowDetail.timeZone === ""
    ) {
      isValidationFail = true;
      showAfterTimeout(setIsReqTimeZone, 1000);
    }
    if (
      askNowDetail.typeOfRequest === "Change Role" &&
      askNowDetail.currentClientProgram === ""
    ) {
      setIsCurrentClientProgram(true);
      isValidationFail = true;
    }
    showAfterTimeout(setTteDateForShow, 1000);

    if (!askNowDetail.requestFor.length) {
      setIsRuleFailRequestedFor(true);
      isValidationFail = true;
    }

    if (!askNowDetail.taleoReqId) {
      setIsRuleFailTaleoReqId(true);
      isValidationFail = true;
    }

    if (!askNowDetail.activeTrainee.length) {
      isValidationFail = true;
      setIsTraineeNotSelected(true);
    }
    if (!askNowDetail.tteTrainingDate.length) {
      setIsRuleFailTteDate(true);
      isValidationFail = true;
    }
    showAfterTimeout(setSiteLocShow, 1500);

    if (!askNowDetail.siteLocation.length) {
      setIsRuleFailSiteLocation(true);
      isValidationFail = true;
    }
    showAfterTimeout(setNcShow, 2000);

    if (!askNowDetail.newClientProgram.length) {
      setIsNewClientProgram(true);
      isValidationFail = true;
    }
    showAfterTimeout(setWtShow, 2500);

    if (!askNowDetail.waveTrainer.length) {
      setIsRuleFailWaveTrainer(true);
      isValidationFail = true;
    }
    showAfterTimeout(setManagerShow, 3000);

    if (!askNowDetail.manager.length) {
      setIsRuleFailManager(true);
      isValidationFail = true;
    }

    if (!isValidationFail) {
      await createTicket();
    }
    showAfterTimeout(setFinishedGenrating, 9500);
  };

  const closeGeneratingAskNowTicket = () => {
    if (ritmHeading === true) {
      setResetActiveTrainee(true);
    }
    setTaleoReqIdShow(false);
    setIsRuleFailTaleoReqId(false);
    setIsTraineeNotSelected(false);
    setIsRuleFailTteDate(false);
    setRequestedForShow(false);
    setIsRuleFailRequestedFor(false);
    setIsCurrentClientProgram(false);
    setIsReqDateTime(false);
    setIsReqTimeZone(false);
    setSiteLocShow(false);
    setIsRuleFailSiteLocation(false);
    setNcShow(false);
    setIsNewClientProgram(false);
    setWtShow(false);
    setIsRuleFailWaveTrainer(false);
    setManagerShow(false);
    setIsRuleFailManager(false);
    setCreateAskNowHeading(false);
    setCreateAskNowSuccess(false);
    setCreateAskNowFacilitiesHeading(false);
    setCreateAskNowFacilitiesSuccess(false);
    setRitmHeading(false);
    setRitmShow(false);
    setUploadRitmHeading(false);
    setShowRitmUpload(false);
    setFinishedGenrating(false);
    setGenerateOpen(false);
    setIdmTicketError(false);
    setFacTicketError(false);

    setIsTicketClosed(true);
  };

  const idmResponseModalProps = {
    generateOpen,
    traineeForShow,
    isTraineeNotSelected,
    taleoReqIdShow,
    isRuleFailTaleoReqId,
    requestedForShow,
    isRuleFailRequestedFor,
    isReqDateTime,
    askNowDetail,
    isReqTimeZone,
    tteDateForShow,
    isRuleFailTteDate,
    siteLocShow,
    isRuleFailSiteLocation,
    ncShow,
    isCurrentClientProgram,
    isNewClientProgram,
    wtShow,
    isRuleFailWaveTrainer,
    managerShow,
    isRuleFailManager,
    createAskNowHeading,
    createAskNowSuccess,
    createAskNowFacilitiesHeading,
    createAskNowFacilitiesSuccess,
    reqNumber,
    facNumber,
    ritmHeading,
    ritmShow,
    ritmNumber,
    uploadRitmHeading,
    showRitmUpload,
    showHeadsetNoticifation,
    idmTicketError,
    facTicketError,
    finishedGenrating,
    closeGeneratingAskNowTicket,
  };

  return (
    <div>
      {loading ? <BackdropComponent /> : null}
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>

      <Dialog
        PaperProps={{
          sx: {
            backgroundColor: "#f0f0f0",
          },
        }}
        fullScreen
        open={openCreateIdm}
        onClose={hanldeIdmClose}
        TransitionComponent={Transition}
      >
        <AppBar className={getAppBarClassName()} sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              // color="inherit"
              color="black"
              onClick={hanldeIdmClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1, fontSize: "18px", fontWeight: "bold" }}
              color="black"
              variant="h5"
              component="div"
            >
              {t("Create AskNow IDM Request")}
            </Typography>
          </Toolbar>
        </AppBar>
        <Grid container>
          <Grid item xs={4}>
            <CreateIdmTicketsInputs
              rosterId={props.rosterId}
              classRequestId={props.classRequestId}
              askNowTDT={props.askNowTDT}
              ttfTrainerData={props.ttfTrainerData}
            />
          </Grid>
          <Grid item xs={8} className={"m-5-0px"}>
            <Box sx={{ height: 725, width: "100%", padding: 20 }}>
              {loading || idmLoading ? (
                <SpinnerWithTime
                  initialTime={
                    traineeDetails.activeTrainees === 0
                      ? 30
                      : 30 + Math.floor(1.5 * traineeDetails.activeTrainees)
                  }
                />
              ) : null}
              <SnackBar snack={snack} snackReset={snackReset}></SnackBar>

              <DataGrid
                columnVisibilityModel={{
                  classTraineeID: false,
                }}
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "bold",
                  },
                }}
                rows={currentProjectCodes}
                columns={columns}
                pageSize={100}
                rowsPerPageOptions={[100]}
                checkboxSelection
                disableSelectionOnClick
                rowHeight={30}
                getRowId={(row) => row.uniqueId}
                isRowSelectable={(rowData) =>
                  requestType !== "Activation (New Hire or Reactivation)"
                    ? rowData.row.RITM === "" &&
                      rowData.row.activeInAD === "Yes"
                    : rowData.row.RITM === "" &&
                      rowData.row.activeInAD !== "Yes"
                }
                onSelectionModelChange={(newSelection) => {
                  const extractedIds = newSelection
                    .map((id) => {
                      const parts = id.split("-");
                      return parts[0].length === 7 ? parts[0] : null;
                    })
                    .filter((id) => id !== null);

                  const uniqueIds = [...new Set(extractedIds)];

                  const pickedRows = currentProjectCodes.filter((row) =>
                    uniqueIds.includes(row.oracleId),
                  );

                  setSelectedRows(
                    pickedRows.map((selectedTrainee) => ({
                      oracleId: selectedTrainee.oracleId,
                      classTraineeId: selectedTrainee.classTraineeID,
                      firstName: selectedTrainee.firstName,
                      lastName: selectedTrainee.lastName,
                      cppClientCode: selectedTrainee.cppClientCode,
                      cppProgramCode: selectedTrainee.cppProgramCode,
                      cppProjectCode: selectedTrainee.cppProjectCode,
                      jobTitle: selectedTrainee.jobTitle,
                      locationId: selectedTrainee.locationId,
                      department: selectedTrainee.department,
                    })),
                  );
                }}
              />
            </Box>
          </Grid>
        </Grid>
        <Grid container sx={{ padding: "5px", paddingLeft: "600px" }}>
          <Grid item xs={5} className={"m-5-0px"}>
            <div>
              <AsttButtonDark onClick={ValidateCreateIdmTicket}>
                {t("GENERATE IDM TICKET")}
              </AsttButtonDark>
            </div>
          </Grid>
        </Grid>
      </Dialog>
      <IDMGenerateResponseModal
        {...idmResponseModalProps}
      ></IDMGenerateResponseModal>
    </div>
  );
};

CreateIdmTickets.propTypes = {
  rosterId: PropTypes.string,
  classRequestId: PropTypes.string,
  askNowTDT: PropTypes.string,
  ttfTrainerData: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func,
};

export default CreateIdmTickets;
